<template>
  <div
    class="subheader"
    :class="[`subheader--${subheaderStyle}`, className]"
    @click.stop="$emit('click')"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from '@/composition/vue/compositionApi'

export default defineComponent({
  inheritAttrs: false,
  props: {
    subheaderStyle: {
      type: String as PropType<'bold' | 'caption'>,
      default: 'bold',
    },
    className: {
      type: String,
      default: 'px-3',
    },
  },
  emits: {
    click: () => true,
  },
})
</script>

<style lang="scss" scoped>
.subheader {
  color: $emphasize;
  &--bold {
    padding-top: 12px;
    padding-bottom: 6px;
    font-weight: $bold-font;
    line-height: 20px;
  }
  &--caption {
    padding-top: 8px;
    padding-bottom: 5px;
    font-size: $sm-font;
    font-weight: $bold-font;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    line-height: 16px;
    color: $emphasize;
  }
}
</style>
